export default "__VITE_PUBLIC_ASSET__e5d841e6__"